import { render, staticRenderFns } from "./CoursewareUnitItemDialogExport.vue?vue&type=template&id=f0edd23a&"
import script from "./CoursewareUnitItemDialogExport.vue?vue&type=script&lang=js&"
export * from "./CoursewareUnitItemDialogExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports